module.exports = __webpack_public_path__ + "img/819.532f6b02.png";